<template>
  <div v-if="catalogDetails">
    <div class="d-flex pt-2 catalog-header">
      <div class="flex-grow-1 mr-3">
        <div class="catalog-name">
          <i
            :class="productCategory.icon"
            class="pr-1"
          />
          {{ catalogDetails.name }}
        </div>
        <div class="catalog-type">
          <span>
            <i
              class="mr-1"
              :class="orderSchema.icon"
            />
            {{ orderSchema.text }}
          </span>
        </div>
      </div>

      <div class="ml-4 mt-1 d-flex">
        <i
          v-tippy
          class="fas fa-times secondary-icon smaller-icon"
          :content="$t('general.close')"
          @click="$router.push(`/payee/${payeeId}/shop/${catalogId}/orders`)"
        />
      </div>
    </div>

    <div class="d-flex">
      <div
        class="row no-gutters flex-column pr-3 justify-content-start mx-0 pt-1"
        style="min-width: 200px; margin-top: 10px"
      >
        <div
          v-for="r in menuItems"
          :key="r.route"
          class="col-12 col-sm-6 col-md-auto page-route mb-2 hover-underline"
          :class="r.route === selected ? 'active' : ''"
          @click.prevent="select(r)"
        >
          <i :class="r.icon" />
          <span class="text">
            {{ r.text }}
          </span>
        </div>
      </div>

      <div
        class="flex-grow-1"
        style="overflow-y: auto; max-height: calc(100vh - 200px);"
      >
        <div
          v-if="selected === 'name'"
          class="settings-box position-relative"
          style="max-width: 700px;"
        >
          <CatalogForm
            :catalog="catalogDetails"
            @close="back"
            @refresh="request"
          />
        </div>
        <div
          v-else-if="selected === 'fields'"
          class="settings-box position-relative"
          style="max-width: 1200px;"
        >
          <ListingFieldsSettings
            :catalog="catalogDetails"
            @close="back"
            @refresh="request"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="mt-2"
  >
    <Loader />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CatalogForm from './catalogs/CatalogForm';
import ListingFieldsSettings from './settings/ListingFieldsSettings';

export default {
  props: {
    catalogId: String,
  },
  data: () => ({
    selected: 'name',
  }),
  components: {
    CatalogForm,
    ListingFieldsSettings,
  },
  computed: {
    ...mapGetters(['payeeId']),
    ...mapGetters('shop', [
      'productCategories',
      'orderSchemas',
      'catalogDetails',
    ]),
    menuItems() {
      return [
        {
          route: 'name',
          text: this.$t('general.name'),
        },
        {
          route: 'fields',
          text: this.$t('shop.fields.title'),
        },
      ];
    },
    productCategory() {
      if (!this.catalogDetails) return {};
      return this.productCategories
        .find((x) => x.key === this.catalogDetails.productCategory);
    },
    orderSchema() {
      return this.orderSchemas
        .find((x) => x.key === this.catalogDetails.orderSchema);
    },
  },
  methods: {
    ...mapActions('shop', ['getShopCatalog']),
    select(r) {
      this.selected = r.route;
    },
    request() {
      this.getShopCatalog({
        params: {
          catalogId: this.catalogId,
        },
      });
    },
    back() {
      this.$router.push(`/payee/${this.payeeId}/shop/${this.catalogId}/orders`);
    },
  },
  created() {
    if (!this.catalogDetails) {
      this.request();
    }
  },
};
</script>

<style lang="scss" scoped>
  .catalog-name {
    font-weight: 500;
    font-size: 18px;
    min-width: 400px;
    margin-top: 2px;
  }

  .catalog-type {
    color: #666;
    font-size: 0.7rem;
  }

  .catalog-header {
    margin-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
  }
</style>
